import React from "react";
import TeamListSlider from "./TeamListSlider";
import TeamItem from "./TeamItem";


import {Container} from "react-bootstrap";
import {useFetchTeams} from "../../features/team/teamApi";


const TeamList = () => {
    const {data:teams} = useFetchTeams();

    if (!teams) {
        return <></>;
    }

    return (
        <>
            <Container>
                <TeamListSlider />
                <div>
                    <h1 className={'text-center mt-4'}> TEAMS </h1>
                    <div className="d-flex justify-content-center flex-wrap">
                        {teams.map((team) => (
                            <TeamItem key={team.id} team={team} />
                        ))}
                    </div>
                </div>
            </Container>
        </>
    );
};
export default TeamList;
